import axios from '../core/axios';

import { ApiConstants } from './api-constants';
export class LeadsService {
  static createLead = async (data: {
    name: string;
    title?: string;
    agency?: string;
    sport?: string;
    status?: string;
    email?: string;
    phone?: string;
  }) => {
    return await (
      await axios.post(ApiConstants.LEADS_API.CREATE_LEAD.URL(), data)
    ).data;
  };
  static getAllLeads = async (
    page: number,
    limit: number,
    mine: boolean = false,
    search: string = '',
    sport?: string,
    sort?: string,
    lastModifiedFrom?: string,
    lastModifiedTo?: string,
    lastModifiedDate?: string,
    assignedTo?: string,
    agencyName?: string,
  ) => {
    return await (
      await axios.get(
        ApiConstants.LEADS_API.GET_ALL_LEADS.URL(page, limit, mine, search, sport, sort) +
          ApiConstants.LEADS_API.GET_ALL_LEADS.QUERY_PARAMS({
            lastModifiedFrom,
            lastModifiedTo,
            lastModifiedDate,
            assignedTo,
            agencyName,
          }),
      )
    ).data;
  };

  static updateLead = async (leadId: string, data: any) => {
    return await (
      await axios.patch(ApiConstants.LEADS_API.EDIT_LEAD.URL(leadId), data)
    ).data;
  };

  static deleteLead = async (leadId: string) => {
    return await (
      await axios.delete(ApiConstants.LEADS_API.DELETE_LEAD.URL(leadId))
    ).data;
  };

  static getAgencyDropdowns = async () => {
    return await (
      await axios.get(ApiConstants.LEADS_API.AGENCY_DROPDOWN.URL())
    ).data;
  };
  static getAssigneeDropdowns = async () => {
    return await (
      await axios.get(ApiConstants.LEADS_API.ASSIGNEE_DROPDOWN.URL())
    ).data;
  };
  static getLeadTypes = async () => {
    return await (
      await axios.get(ApiConstants.LEADS_API.GET_LEAD_TYPES.URL())
    ).data;
  };

  static getLeadTypeDropdowns = async (leadTypeId: string) => {
    return await (
      await axios.get(ApiConstants.LEADS_API.GET_LEADS_DROPDOWNS.URL(leadTypeId))
    ).data;
  };
  static getDemographicProData = async (id: string) => {
    return await (
      await axios.get(ApiConstants.LEADS_API.DEMOGRAPHIC_PRO_DATA.URL(id))
    ).data;
  };
  static async getLeadPresignedUrl(fileName: string, type: string, size: string, leadId: string) {
    const response = await axios.get(
      ApiConstants.LEADS_API.GET_PRESIGNED_URL.URL(fileName, type, size, leadId),
    );
    return response?.data || response;
  }
}
